/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_VietnameseInputs */



/**
* | output |
* | --- |
* | "Vietnamese" |
*
* @param {Speechmatics_Target_Language_VietnameseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_vietnamese = /** @type {((inputs?: Speechmatics_Target_Language_VietnameseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_VietnameseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vietnamien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vietnamesisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("vietnamita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("вьетнамский")
	if (locale === "es") return /** @type {LocalizedString} */ ("vietnamita")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("越南语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ベトナム語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वियतनामी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("vietnamita")
	return /** @type {LocalizedString} */ ("Vietnamese")
});